import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryLoading: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBatteryLoading"><Path d="M7.75 5.5H1.5V18.5H5.25M15.75 5.5H19.5V18.5H13.25M12.25 5.75L7.5 12H13.5L8.75 18.25M19.5 8.5H22.5V15.5H19.5V8.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBatteryLoading;
